import { Component, HostListener, Inject, OnInit } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { ROTATE_TYPES } from '@root/app.config';
import { EngineService } from '@core/services/engine/engine.service';
import { ModalService } from '@core/services/modal/modal.service';
import { ShareService } from '@core/services/share-data/share-data.service';
import { getScreenOrientation } from '@core/helpers/orientation.utils';

@Component({
	selector: 'app-rotate-device-modal',
	templateUrl: './rotate-device-modal.component.html',
	styleUrls: ['./rotate-device-modal.component.scss', './rotate-device-modal.responsive.scss'],
})
export class RotateDeviceModalComponent implements OnInit {
	static readonly ID = crypto.randomUUID();

	rotateType: string;
	rotateTypes = ROTATE_TYPES;
	orientation = getScreenOrientation();
	isSampleProject: boolean;

	@HostListener('window:orientationchange', ['$event']) onOrientationChange() {
		if (getScreenOrientation() === 'portrait' && this.rotateType === ROTATE_TYPES.to_portrait) {
			this.engineService.sceneOrientation = getScreenOrientation();
			this.dialogRef.close();
		}

		if (getScreenOrientation() === 'landscape' && this.rotateType === ROTATE_TYPES.to_landscape) {
			this.engineService.sceneOrientation = getScreenOrientation();
			this.dialogRef.close();
		}
	}

	get isSmallLandscapeScreen(): boolean {
		return this.rotateType === this.rotateTypes.to_portrait && window.innerWidth <= 500;
	}

	constructor(
		private modalService: ModalService,
		private shareService: ShareService,
		private engineService: EngineService,
		public dialogRef: MatDialogRef<RotateDeviceModalComponent>,
		@Inject(MAT_DIALOG_DATA) public data: { rotateType: string; isSampleProject: boolean },
	) {
		this.rotateType = this.data.rotateType;
		this.isSampleProject = this.data.isSampleProject;
	}

	ngOnInit(): void {
		this.modalService.liftUpModal(this.dialogRef);
	}

	closeDialog(): void {
		this.dialogRef.close();
	}

	resetScene(): void {
		this.dialogRef.close();
		this.engineService.boundingBoxesSettings = {};
		this.engineService.sceneOrientation = getScreenOrientation();
		this.engineService.setIVCameraSettings();
		this.engineService.setGizmoControl(true);
		this.engineService.setIVSampleProject();
		this.engineService.createModelsFromStorage();
		this.engineService.resetLineByPoints(false);
	}

	async restartAutoDetection() {
		this.shareService.setOpeningFitReset(true);
		this.shareService.setSelectOpeningMode(true);
		await this.shareService.setblindDisplayStatusesRequest();
		this.engineService.toggleAllRootMeshes(false);
		this.dialogRef.close();
	}
}
